var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "b-modal",
    {
      ref: "taichi-notification",
      attrs: {
        id: "taichiNotificationModal",
        title: "系統通知",
        "ok-title": _vm.isSummaryMode ? "關閉" : "進入教室",
        "cancel-title": "關閉",
        centered: "",
        "ok-disabled":
          !_vm.isSummaryMode && _vm.notificationAction !== "access_classroom",
        "ok-only": _vm.isSummaryMode,
        "header-bg-variant": "primary",
      },
      on: {
        ok: function ($event) {
          _vm.isSummaryMode ? _vm.closeModal() : _vm.handleAction()
        },
        cancel: _vm.closeModal,
        hidden: _vm.onModalHidden,
      },
    },
    [
      _vm.isSummaryMode
        ? [
            _c(
              "h4",
              {
                staticClass: "text-center",
              },
              [
                _vm._v(
                  "您有 " + _vm._s(_vm.messageQueue.length + 1) + " 則未讀通知"
                ),
              ]
            ),
            _c(
              "p",
              {
                staticClass: "text-center",
              },
              [_vm._v("點擊關閉後將逐條顯示")]
            ),
          ]
        : [
            _c(
              "h4",
              {
                staticClass: "text-center",
              },
              [_vm._v(_vm._s(_vm.notificationTitle))]
            ),
            _c(
              "p",
              {
                staticClass: "text-center",
              },
              [_vm._v(_vm._s(_vm.notificationContent))]
            ),
            _vm.messageQueue.length > 0
              ? _c(
                  "p",
                  {
                    staticClass: "text-center text-muted small",
                  },
                  [
                    _vm._v(
                      "還有 " + _vm._s(_vm.messageQueue.length) + " 則未讀通知"
                    ),
                  ]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }